var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShadowIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 229,
    height: 104,
    viewBox: "0 0 229 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_248_4098)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M198.697 39.7553C200.047 49.5613 163.476 62.9807 117.014 69.7283C70.5519 76.4759 31.793 73.9966 30.4435 64.1906C29.094 54.3846 65.6649 40.9653 112.127 34.2176C158.589 27.47 197.348 29.9493 198.697 39.7553Z",
    fill: "#A2A2A2",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.697 39.7553C200.047 49.5613 163.476 62.9807 117.014 69.7283C70.5519 76.4759 31.793 73.9966 30.4435 64.1906C29.094 54.3846 65.6649 40.9653 112.127 34.2176C158.589 27.47 197.348 29.9493 198.697 39.7553Z",
    fill: "#A2A2A2",
    fillOpacity: 0.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_248_4098",
    x: 0.407295,
    y: 0.418213,
    width: 228.326,
    height: 103.11,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15,
    result: "effect1_foregroundBlur_248_4098"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShadowIcon);
export default __webpack_public_path__ + "static/media/ShadowIcon.2bfac64982b87f4317117f2f0b8e562d.svg";
export { ForwardRef as ReactComponent };